/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const REFRESH_CHIP_CSHCN_RATE_AUDIT_DISPLAY =
  'REFRESH_CHIP_CSHCN_RATE_AUDIT_DISPLAY';
export const SET_SELECTED_CHIP_CSHCN_RATE_AUDIT =
  'SET_SELECTED_CHIP_CSHCN_RATE_AUDIT';
export const GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES =
  'GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES';
export const GET_RESULT_CHIP_CSHCN_RATE_AUDIT =
  'GET_RESULT_CHIP_CSHCN_RATE_AUDIT';

export const REFRESH_CHIP_CSHCN_RATE_AUDIT = 'REFRESH_CHIP_CSHCN_RATE_AUDIT';
export const GET_CHIP_CSHCN_RATE_AUDIT_MAX_QUARTER =
  'GET_CHIP_CSHCN_RATE_AUDIT_MAX_QUARTER';

export const IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES =
  'IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES';
